export enum ReportChangeType {
  Fields = "Fields",
  Signature = "Signature",
  InvitationAccepted = "InvitationAccepted",
  RoleSpecificInfo = "RoleSpecificInfo",
  AccidentDrawingCleared = "AccidentDrawingCleared",
  AccidentDrawingActionsAdded = "AccidentDrawingActionsAdded",
  AccidentDrawingActionDeleted = "AccidentDrawingActionDeleted",
}
